import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(email, password);
    if (result.success) navigate('/dashboard');
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>HRMS</h1>
        <p className="login-subtitle">Human Resource Management System</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email" required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" required />
          </div>
          <br></br>
          <button type="submit" className="btn-primary btn-block" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        {/* <div className="login-demo">
          <p>Demo Credentials:</p>
          <small>Admin: admin@hrms.com / admin123</small><br/>
          <small>HR: hr@hrms.com / hr123456</small><br/>
          <small>Employee: john@hrms.com / john1234</small>
        </div> */}
      </div>
    </div>
  );
};

export default LoginPage;
